import appConfig from '../config'

export const isApacRegion = appConfig.region === 'APAC'
export const isGeminiRegion = appConfig.region === 'GEMINI'
export const isEmeaRegion = appConfig.region === 'EMEA'
export const isNARegion = appConfig.region === 'NA'
export const isVisionXShell = appConfig.mfe === true
